import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import Map from '../components/Map';
import Chat from '../components/Chat';
import ConversationsBar from '../components/ConversationsBar';
import Onboarding from '../components/Onboarding';

export default function Dashboard({ session, unreadCounts, setUnreadCounts, clearUnread, onChatClose, blockedIds, onBlock, totalUnread }) {
  const [chatUser, setChatUser] = useState(null);
  const [nearbyUsers, setNearbyUsers] = useState([]);
  const [showOnboarding, setShowOnboarding] = useState(false);

  // Afficher l'onboarding au premier login
  useEffect(() => {
    const key = `nearme_onboarded_${session?.user?.id}`;
    if (!localStorage.getItem(key)) {
      setShowOnboarding(true);
    }
  }, [session?.user?.id]);

  const dismissOnboarding = () => {
    const key = `nearme_onboarded_${session?.user?.id}`;
    localStorage.setItem(key, '1');
    setShowOnboarding(false);
  };

  const openChat = (user) => {
    setChatUser(user);
    clearUnread(user.id);
  };

  const handleBlock = (userId) => {
    onBlock(userId);
    setNearbyUsers(prev => prev.filter(u => u.id !== userId));
    if (chatUser?.id === userId) { setChatUser(null); onChatClose(); }
  };

  return (
    <div style={{ background:'#080808', minHeight:'100vh' }}>
      <Navbar session={session} totalUnread={totalUnread}/>
      <Map
        session={session}
        onOpenChat={openChat}
        onUsersUpdate={users => setNearbyUsers(users.filter(u => !blockedIds.has(u.id)))}
        unreadCounts={unreadCounts}
        onBlock={handleBlock}
        blockedIds={blockedIds}
      />
      <ConversationsBar
        session={session}
        nearbyUsers={nearbyUsers}
        onOpenChat={openChat}
        unreadCounts={unreadCounts}
        setUnreadCounts={setUnreadCounts}
      />
      {chatUser && !blockedIds.has(chatUser.id) && (
        <Chat
          user={chatUser}
          session={session}
          onClose={() => { setChatUser(null); onChatClose(); }}
          onBlock={handleBlock}
        />
      )}
      {showOnboarding && <Onboarding onDone={dismissOnboarding}/>}
    </div>
  );
}
